import Image from 'next/image'
import Link from 'next/link'

import { Footer } from '@/components'
import { contactUsURL } from '@/libs/constants/external-url'
import { rocketFixing } from '@/libs/constants/images-library'

export type TMaintenance = {
  isMaintenanceFeature: boolean
}

export default function Maintenance({ isMaintenanceFeature }: Readonly<TMaintenance>) {
  return (
    <div className='flex h-nav-screen w-full flex-col items-center justify-center gap-4'>
      <Image src={rocketFixing?.src} alt={rocketFixing?.alt} width={160} height={160} />
      <h1 className='text-center text-2xl font-semibold'>
        {isMaintenanceFeature ? 'Feature' : 'Site'} Under Maintenance
      </h1>
      <p className='max-w-sm text-center text-base font-normal text-pop-neutral-gray'>
        We are performing maintenance to improve the user experience. We will be back shortly.
      </p>
      <Link
        href={contactUsURL}
        className='min-w-[320px] rounded-full border-pop-business-blue bg-pop-business-blue px-4 py-3 text-center text-sm font-medium text-white'
      >
        Contact Us
      </Link>
      <Footer />
    </div>
  )
}
